var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.$route.name === 'assistance')?_c('AssistanceRequest'):_vm._e(),(_vm.$route.name === 'assistance_view')?_c('AssistanceView'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }